import $http from './http';

// 用能报表---日报查询和搜索（要权限) --张东秋
export const getDayData = data => {
    return $http.post('/collect/power_collection/getDayData', data);
};

//用能报表--- 月报查询和搜索（要权限) --张东秋
export const getMonthData = data => {
    return $http.post('/collect/power_collection/getMonthData', data);
};

//用能报表--- 年报查询和搜索（要权限) --张东秋
export const getYearData = data => {
    return $http.post('/collect/power_collection/getYearData', data);
};

//用能报表--- 导出（要权限) --张东秋
export const getExcel = data => {
    return $http.post('/collect/power_collection/getExcel', data, {
        responseType: 'blob'
    });
};

//用能集抄--- 获取列表（要权限) --张东秋
export const getEnergyList = data => {
    return $http.post('/collect/energy/getEnergyList', data);
};

//用能集抄--- 导出（要权限) --张东秋
export const getCollectionExcel = data => {
    return $http.post('/collect/energy/getExcel', data, {
        responseType: 'blob'
    });
};

// 用水报表
export const getDayDataWater = data => {
    return $http.post('/collect/water_collection/getDayData', data);
};

//用水报表
export const getMonthDataWater = data => {
    return $http.post('/collect/water_collection/getMonthData', data);
};

//用水报表
export const getYearDataWater = data => {
    return $http.post('/collect/water_collection/getYearData', data);
};

//用水报表
export const getExcelWater = data => {
    return $http.post('/collect/water_collection/getExcel', data, {
        responseType: 'blob'
    });
};